"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _bind = _interopRequireDefault(require("classnames/bind"));

var _mobxReact = require("mobx-react");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function (nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

require("./Slider.css");

var _styles = {
  "slider": "Slider__slider___1Qf79"
};

const styles = _bind.default.bind(_styles);

const Slider = (0, _mobxReact.observer)(({
  className,
  dataTestId,
  onChange,
  onCommitChange,
  value,
  disabled = false,
  lowerBound = 0,
  upperBound = 100,
  ...props
}) => {
  const composedClassname = (0, _bind.default)(styles('slider'), className);
  const rangeRef = (0, _react.useRef)(null);
  const [trackedValue, setTrackedValue] = (0, _react.useState)(value);
  (0, _react.useEffect)(() => {
    setTrackedValue(value);

    if (rangeRef.current !== null) {
      const progressValue = Math.floor((value - lowerBound) / (upperBound - lowerBound) * 100);
      rangeRef.current.style.backgroundSize = `${progressValue}% 100%`;

      if (value > upperBound || value < lowerBound || disabled) {
        rangeRef.current.style.backgroundImage = 'none';
        rangeRef.current.style.backgroundColor = '#C7C7C7';
      }
    }
  }, [value]);
  return _react.default.createElement("div", {
    className: composedClassname,
    ...props
  }, _react.default.createElement("input", {
    type: 'range',
    min: lowerBound,
    max: upperBound,
    value: value,
    onChange: e => {
      setTrackedValue(value);
      onChange(Number(e.target.value));
    },
    disabled: disabled,
    "data-testid": dataTestId,
    "aria-valuemin": lowerBound,
    "aria-valuemax": upperBound,
    "aria-valuenow": value,
    ref: rangeRef,
    onMouseUp: () => onCommitChange && onCommitChange(trackedValue)
  }));
});
var _default = Slider;
exports.default = _default;